import Vue from 'vue';
import ToastV2 from '@/components/widgets/toast-v2.vue';

const ToastV2Component = Vue.extend(ToastV2);

const ToastV2Plugin = {
  install(Vue) {
    const instance = new ToastV2Component();
    instance.$mount();
    // Append the toast element to document body
    document.body.appendChild(instance.$el);
    
    // Make it available globally as $toastV2
    Vue.prototype.$toastV2 = {
      success: (message, duration, position) => instance.success(message, duration, position),
      error: (message, duration, position) => instance.error(message, duration, position),
      warning: (message, duration, position) => instance.warning(message, duration, position),
      info: (message, duration, position) => instance.info(message, duration, position),
      show: (message, type, duration, position) => instance.show(message, type, duration, position)
    };
  }
};

export default ToastV2Plugin;
